import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "row"]

  open() {
    if (this.hasRowTarget) this.rowTarget.hidden = false
    if (this.hasTriggerTarget) this.triggerTarget.hidden = true
  }
}
